import { useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { useNavigate } from 'react-router-dom';

import DotNavigation from '@App/components/DotNavigation/DotNavigation';
import MaplibreMap from '@App/components/MaplibreMap/MaplibreMap';
import Markers from '@App/components/Markers/Markers';
import { useTranslation } from '@utils/i18n/i18n';

import { CASE_STUDIES } from './case-studies.constants';

import './case-studies.css';

function CaseStudies() {
  const navigate = useNavigate();

  const [selectedCaseStudy, setSelectedCaseStudy] = useState(CASE_STUDIES[0].id);

  const { t } = useTranslation();

  const activeCaseStudy = CASE_STUDIES.find(({ id }) => id === selectedCaseStudy) ?? CASE_STUDIES[0];

  return (
    <section className="case-studies">
      <h2>{t('Case studies')}</h2>
      <div className="case-studies__panel">
        <div className="case-studies__intro">
          <div className="case-studies__content">
            <p>{t('In the ENHANCE project, the OneHealth approach is put to the test in two Mediterraneancase studies with contrasting coastal contexts')}</p>
            <ul>
              <li>{t('Catalan Coast in Spain')}</li>
              <li>{t('Pagasitikos Gulf in Greece')}</li>
            </ul>
            <p>{t('Select the case study of your interest to explore the local context, challenges and results.')}</p>
          </div>
          <MaplibreMap
            initialCenter={[12.5, 40.2]}
            initialZoom={3.7}
            className="case-studies__map"
          >
            <Markers
              selectedMarker={selectedCaseStudy}
              setSelectedMarker={setSelectedCaseStudy}
              markers={CASE_STUDIES}
            />
          </MaplibreMap>
        </div>
        <div className="case-studies__detail">
          <div className="case-studies__detail-media">
            <img
              alt={t(activeCaseStudy.imageAlt)}
              className="case-studies__detail-image"
              src={activeCaseStudy.imagePath}
              loading="lazy"
            />
          </div>
          <div className="case-studies__detail-content">
            <h3>{t(activeCaseStudy.detailTitle)}</h3>
            <p>{t(activeCaseStudy.description)}</p>
            <div className="case-studies__detail-footer">
              <Button
                className="case-studies__detail-button"
                type="button"
                onClick={() => navigate(`/${activeCaseStudy.id}`)}
              >
                {t(activeCaseStudy.buttonLabel)}
              </Button>
            </div>
          </div>
          <DotNavigation
            ariaLabel={t('Case study navigation')}
            activeId={activeCaseStudy.id}
            className="case-studies__dots"
            items={CASE_STUDIES}
            getItemAriaLabel={caseStudy => t(caseStudy.label)}
            onSelect={setSelectedCaseStudy}
          />
        </div>
      </div>
    </section>
  );
}

export default CaseStudies;
